import { defineStore } from 'pinia';
import CompanyLabelsAPI from 'dashboard/api/companyLabels';

export const useCompanyLabelsStore = defineStore('companyLabels', {
  state: () => ({
    labels: [],
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  }),

  getters: {
    getLabels: state => state.labels,
    getLabelByTitle: state => title =>
      state.labels.find(l => l.title === title),
    getLabelColorMap: state =>
      Object.fromEntries(state.labels.map(l => [l.title, l.color])),
  },

  actions: {
    async fetchAll() {
      this.isFetching = true;
      try {
        const { data } = await CompanyLabelsAPI.getAll();
        this.labels = data.payload || [];
      } finally {
        this.isFetching = false;
      }
    },

    async create({ title, color = '#6B7280', description = '' }) {
      this.isCreating = true;
      try {
        const { data } = await CompanyLabelsAPI.create({
          title,
          color,
          description,
        });
        this.labels.push(data.payload);
        return data.payload;
      } finally {
        this.isCreating = false;
      }
    },

    async update(id, attrs) {
      this.isUpdating = true;
      try {
        const { data } = await CompanyLabelsAPI.update(id, attrs);
        const idx = this.labels.findIndex(l => l.id === id);
        if (idx !== -1) this.labels[idx] = data.payload;
        return data.payload;
      } finally {
        this.isUpdating = false;
      }
    },

    async delete(id) {
      this.isDeleting = true;
      try {
        await CompanyLabelsAPI.delete(id);
        this.labels = this.labels.filter(l => l.id !== id);
      } finally {
        this.isDeleting = false;
      }
    },

    async getCompanyLabels(companyId) {
      try {
        const { data } = await CompanyLabelsAPI.getCompanyLabels(companyId);
        return data.payload || [];
      } catch {
        return [];
      }
    },

    async updateCompanyLabels(companyId, labels) {
      const { data } = await CompanyLabelsAPI.updateCompanyLabels(
        companyId,
        labels
      );
      return data.payload || [];
    },
  },
});
